import { combineLatest } from 'rxjs';
import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
import { Filter } from 'src/app/core/models/filter';
const getSupplierAccountsQuery = gql`query supplier_accounts($limit:Int,$offset:Int){
  supplier_accounts(order_by:{created_at: desc},limit:$limit, offset: $offset){
    id
    created_at
    updated_at
    supplier_id
    account_number
    supplier {
      id
      name
      business_name
    }

  }
}`;

const getSupplierAccountsAggregateQuery = gql`query supplier_accounts_aggregate{
  supplier_accounts_aggregate{
    aggregate{
      count
    }
  }
}`
@Injectable({
  providedIn: 'root'
})
export class GetSupplierAccountsService {
  /* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
  /* -------------------------- Get Supplier Accounts ------------------------- */
  getSupplierAccounts(filter: Filter){
    return combineLatest([
      this.apollo.use('external').query({
        query: getSupplierAccountsQuery,
        variables:{
          limit: filter.limit,
          offset: filter.offset
        }
      }).pipe(pluck('data', 'supplier_accounts')),
      this.apollo.use('external').query({
        query: getSupplierAccountsAggregateQuery
      }).pipe(pluck('data', 'supplier_accounts_aggregate', 'aggregate', 'count'))
    ])
  }
}
